import './GaugeResponsiveLabel.css';
export var parentSvgStyle = '_13c0oci1-3-5-0';
export var responsiveLabelContainer = '_13c0oci0-3-5-0';